import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
export const ERROR_CODE = 'generic';
class BaseError extends Error {
  constructor({
    name = 'BaseError',
    code = ERROR_CODE,
    detailsMsg = '',
    originalError = null,
    shouldRefresh = false
  } = {}) {
    const message = `${name} (${detailsMsg || code})`;
    super(message);
    _defineProperty(this, "code", void 0);
    _defineProperty(this, "detailsMsg", void 0);
    _defineProperty(this, "originalError", void 0);
    _defineProperty(this, "shouldRefresh", void 0);
    this.name = name;
    this.code = `${code}`; // force save as string
    this.detailsMsg = detailsMsg;
    this.originalError = originalError;
    this.shouldRefresh = shouldRefresh;
    return this;
  }
  toActionPayload() {
    return {
      code: this.code,
      detailsMsg: this.detailsMsg,
      refresh: this.shouldRefresh
    };
  }
  toTrackingContext() {
    return {
      originalError: this.originalError
    };
  }
}
export default BaseError;